$(document).ready(function(){
    $('body').on('click','#form-suscripcion .button',function(){
      var button = $(this);
      var formData = $('body').find('#form-suscripcion').serializeArray();

      button.addClass('button--loading');

      $.post(data.base_url + 'suscribir', $.param(formData),function(json){
        json = JSON.parse(json);

        if(json.code == 422){
          for(input in json.data){
            $('#form-suscripcion [name='+input+']').addClass('invalid-input').parents('.form-control').attr('data-error-message',json.data[input]).addClass('form-control--invalid');
            $('#form-suscripcion [name='+input+']').siblings('.form-control__text').hide();
            removeClass($('#form-suscripcion [name='+input+']'));
          }
        }

        if(json.code == 200){
          $('#msg-suscripcion').html('<div class="message message--ghost-success" data-module="message"> <div class="message__body"> <p>'+json.msg+'</p> </div> <button class="message__close-button" data-role="close"></button> </div> ');
          $('#form-suscripcion')[0].reset();
        }
        if(json.code == 500){
          $('#msg-suscripcion').html('<div class="message message--ghost-danger" data-module="message"> <div class="message__body"> <p>'+json.msg+'</p> </div> <button class="message__close-button" data-role="close"></button> </div>');
        }

        setTimeout(function () {
          $('#msg-suscripcion .message').remove();
        }, 4000);

        button.removeClass('button--loading');
      });

      return false;
    });

    function removeClass(input){
      setTimeout(function () {
        input.siblings('.form-control__text').show(); //added
        input.removeClass('invalid-input').parents('.form-control').removeClass('form-control--invalid');
      }, 4000);
    }
});
